// @ts-nocheck
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";

export default function CenterPage({ list }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const statusStr = [
    translate(getText("审核中")),
    translate(getText("审核通过")),
    translate(getText("审核拒绝")),
    translate(getText("分配卡号")),
  ];
  
  const getStatusColor = (status) => {
    const colors = {
      1: "text-warning", // 审核中
      2: "text-success", // 审核通过
      3: "text-danger",  // 审核拒绝
      4: "text-primary", // 分配卡号
    };
    return colors[status] || "text-neutral-400";
  };

  const getArray = () => {
    const nodes = [];
    for (const item of list) {
      nodes.push(
        <div
          key={item?.orderNo}
          className="border-b border-neutral-700/50 p-4 md:p-5 hover:bg-neutral-800 transition-colors duration-200 cursor-pointer"
          onClick={() => {
            navigate(`/c2cckinfo/${item?.orderNo}`);
          }}
        >
          <div className="flex justify-between items-center">
            <div className="flex-1">
              <span className="text-base md:text-lg font-medium text-neutral-200">{item?.czNum}</span>
              <div className="mt-1">
                <span className="text-xs md:text-sm text-neutral-400">{item?.createTime}</span>
              </div>
            </div>
            <div className="flex flex-col items-end">
              <div className={`font-medium ${getStatusColor(item?.status)}`}>
                {statusStr[item?.status - 1]}
              </div>
              <div className="text-xs text-neutral-500 mt-1">
                {item?.orderNo}
              </div>
            </div>
          </div>
        </div>
      );
    }
    return nodes;
  };
  
  return (
    <div className="animate-fade-in">
      {list.length > 0 ? (
        <div>{getArray()}</div>
      ) : (
        <div className="flex flex-col items-center justify-center py-16">
          <svg className="w-16 h-16 text-neutral-700 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
          <p className="text-neutral-400 text-base">{translate(getText("没有提款记录"))}</p>
        </div>
      )}
      
      {list.length > 0 && (
        <div className="text-neutral-500 text-xs py-6 text-center border-t border-neutral-800 mt-4">
          {translate(getText("没有更多数据了"))}
        </div>
      )}
    </div>
  );
}
